<template>
  <div id="job-search" class="fill-height" style="background-color: #f5f5f5;">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="5">
          <v-card class="elevation-2 rounded-xl">
            <v-card-title class="py-6 justify-center teal darken-4 white--text rounded-t-xl">
              <h2 class="text-h5 font-weight-bold mb-0">TRA CỨU KẾT QUẢ TUYỂN DỤNG</h2>
            </v-card-title>
            <v-card-text class="pa-6">
              <p class="text-center text-body-1 grey--text text--darken-2 mb-6">
                Vui lòng nhập số điện thoại hoặc CCCD/CMND để tra cứu trạng thái hồ sơ của bạn.
              </p>
              <v-form ref="form" v-model="valid" lazy-validation @submit.prevent>
                <v-text-field
                  v-model="searchQuery"
                  :rules="[v => !!v || 'Vui lòng nhập thông tin tra cứu']"
                  label="Số điện thoại / CCCD"
                  outlined
                  dense
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  class="rounded-lg mb-4"
                  hide-details="auto"
                  @keyup.enter="search"
                ></v-text-field>
              </v-form>
              
              <v-expand-transition>
                <div v-if="hasSearched && !isLoading" class="mt-6">
                   <!-- Placeholder cho kết quả tra cứu -->
                   <v-alert
                     v-if="!searchResult || searchResult.length === 0"
                     type="info"
                     text
                     color="blue-grey"
                     class="rounded-lg mb-0"
                   >
                     Không tìm thấy kết quả phù hợp. Vui lòng kiểm tra lại thông tin.
                   </v-alert>
                   
                   <template v-else>
                     <v-card v-for="(item, index) in searchResult" :key="index" outlined class="rounded-lg border mb-3">
                       <v-card-text>
                         <div class="d-flex justify-space-between mb-2">
                           <span class="font-weight-medium">Họ tên:</span>
                           <span class="font-weight-bold text-uppercase">{{ item.name }}</span>
                         </div>
                         <div class="d-flex justify-space-between mb-2">
                           <span class="font-weight-medium">Vị trí ứng tuyển:</span>
                           <span class="teal--text font-weight-bold">{{ item.job }}</span>
                         </div>
                         <div class="d-flex justify-space-between">
                           <span class="font-weight-medium">Trạng thái:</span>
                           <v-chip small :color="getStatusColor(item.status)" text-color="white" class="font-weight-bold px-3">
                             {{ item.status == 'NEW' ? 'Mới': (item.status == 'ACCEPT' ? 'Duyệt' : 'Không duyệt') }}
                           </v-chip>
                         </div>
                       </v-card-text>
                     </v-card>
                   </template>
                </div>
              </v-expand-transition>
            </v-card-text>
            <v-card-actions class="px-6 pb-6 pt-0">
              <v-btn
                color="teal darken-4"
                block
                dark
                large
                class="rounded-lg font-weight-bold"
                :loading="isLoading"
                @click="search"
                type="button"
              >
                TRA CỨU
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import http from "@/components/services/http-common";

export default {
  name: 'JobSearch',
  data() {
    return {
      valid: true,
      searchQuery: '',
      isLoading: false,
      hasSearched: false,
      searchResult: null,
    };
  },
  methods: {
    search() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        this.hasSearched = true;
        
        http.get('candidates/job-search', { params: { inputSearch: this.searchQuery } })
          .then(res => {
            let data = res.data.data || res.data;
            if (Array.isArray(data) && data.length > 0) {
              this.searchResult = data.map(item => ({
                name: item.name || item.Name || item.hoTen,
                job: item.job || item.Job || item.JobName || item.jobName || item.viTriUngTuyen,
                status: item.status || item.Status || item.trangThai
              }));
            } else {
              this.searchResult = [];
            }
          })
          .catch(err => {
            console.error(err);
            this.searchResult = null;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    getStatusColor(status) {
      switch(status) {
        case 'NEW': return 'orange darken-2';
        case 'ACCEPT': return 'green darken-2';
        case 'Từ chối': return 'red darken-2';
        default: return 'grey darken-2';
      }
    }
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #e0e0e0;
}
</style>
